"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var InputSearch_styled_exports = {};
__export(InputSearch_styled_exports, {
  StyledCloseButton: () => StyledCloseButton,
  StyledErrorIcon: () => StyledErrorIcon,
  StyledHintMessage: () => StyledHintMessage,
  StyledInput: () => StyledInput,
  StyledInputSearchButton: () => StyledInputSearchButton,
  StyledInputSearchContainer: () => StyledInputSearchContainer,
  StyledLabelTitle: () => StyledLabelTitle
});
module.exports = __toCommonJS(InputSearch_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_Button = require("../../atoms/Button/Button.component");
var getInputBorder = function getInputBorder2(theme, errorMode) {
  if (errorMode) {
    return "1px solid ".concat(theme.colors.incorrect.base);
  }
  return "1px solid ".concat(theme.colors.beige[180]);
};
var getIconColor = function getIconColor2(theme, errorMode, darkMode, disabled) {
  if (darkMode) {
    if (disabled) {
      return theme.colors.n[30];
    }
    return errorMode ? theme.colors.n[100] : theme.colors.white;
  }
  if (disabled) {
    return theme.colors.n[60];
  }
  return theme.colors.pr.base;
};
var getTitleColor = function getTitleColor2(theme, errorMode, darkMode, disabled) {
  if (darkMode) {
    if (disabled) {
      return theme.colors.n[30];
    }
    return errorMode ? theme.colors.n[100] : theme.colors.white;
  }
  return disabled ? theme.colors.n[60] : theme.colors.n[100];
};
var getHintTitleColor = function getHintTitleColor2(theme, errorMode, darkMode) {
  if (darkMode) {
    return errorMode ? theme.colors.status.error[20] : theme.colors.beige[140];
  }
  return errorMode ? theme.colors.status.error[100] : theme.colors.beige[180];
};
var getBackgroundColor = function getBackgroundColor2(theme, errorMode, darkMode) {
  var color = "transparent";
  if (darkMode) {
    color = errorMode ? theme.colors.status.error[20] : theme.colors.n[100];
  }
  return color;
};
var getPlaceholderColor = function getPlaceholderColor2(theme, errorMode, darkMode) {
  if (darkMode) {
    return errorMode ? theme.colors.n[100] : theme.colors.beige[140];
  }
  return theme.colors.beige[180];
};
var getBorderFocusColor = function getBorderFocusColor2(theme, errorMode, darkMode) {
  if (errorMode) {
    return theme.colors.status.error[100];
  }
  return darkMode ? theme.colors.white : theme.colors.n["100"];
};
var getDisabledStyles = function getDisabledStyles2(theme, darkMode, disable, withDisabledStyles) {
  return (0, import_styled_components.css)(["background:", ";cursor:", ";border:none;color:", ";"], darkMode ? theme.colors.n[80] : theme.colors.n[10], (disable || withDisabledStyles) && "not-allowed", darkMode ? theme.colors.n[30] : theme.colors.n[60]);
};
var StyledInput = import_styled_components.default.input.withConfig({
  displayName: "InputSearchstyled__StyledInput",
  componentId: "sc-18s6gv0-0"
})(function(_ref) {
  var theme = _ref.theme, darkMode = _ref.darkMode, errorMode = _ref.errorMode, labelText = _ref.labelText, disabled = _ref.disabled, withDisabledStyles = _ref.withDisabledStyles;
  return (0, import_styled_components.css)(["width:100%;border:none;outline:none;font-size:", ";font-family:", ";line-height:24px;color:", ";padding:", ";background-color:transparent;background:", ";border:", ";", ";", ";order:1;height:56px;&::placeholder{color:", ";}", " &:focus{border:", " solid;border-color:", ";outline:none;-webkit-appearance:none;}}&::-webkit-search-cancel-button{display:none;}"], theme.typography.sizes.medium, theme.typography.fonts.primary, getTitleColor(theme, errorMode, darkMode, disabled || withDisabledStyles), labelText ? "26px 106px 6px 12px" : "16px 101px 16px 12px", getBackgroundColor(theme, errorMode, darkMode), getInputBorder(theme, errorMode), (0, import_mixins.withBorderRadius)(theme.measurements.small), darkMode && (0, import_mixins.withBorder)(theme.colors.beige[140]), getPlaceholderColor(theme, errorMode, darkMode), (disabled || withDisabledStyles) && getDisabledStyles(theme, darkMode, disabled, withDisabledStyles), errorMode || errorMode && darkMode ? "1px" : "2px", getBorderFocusColor(theme, errorMode, darkMode));
});
var StyledHintMessage = import_styled_components.default.span.withConfig({
  displayName: "InputSearchstyled__StyledHintMessage",
  componentId: "sc-18s6gv0-1"
})(function(_ref2) {
  var theme = _ref2.theme, errorMode = _ref2.errorMode, darkMode = _ref2.darkMode;
  return (0, import_styled_components.css)(["line-height:24px;font-size:", ";font-family:", ";font-weight:", ";color:", ";display:-webkit-box;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical;width:100%;"], theme.typography.sizes.extraSmall, theme.typography.fonts.primary, theme.typography.weights.regular, getHintTitleColor(theme, errorMode, darkMode));
});
var StyledLabelTitle = import_styled_components.default.div.withConfig({
  displayName: "InputSearchstyled__StyledLabelTitle",
  componentId: "sc-18s6gv0-2"
})(function(_ref3) {
  var theme = _ref3.theme, darkMode = _ref3.darkMode, errorMode = _ref3.errorMode;
  return (0, import_styled_components.css)(["text-align:left;font-family:", ";font-size:", ";line-height:", ";color:", ";width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:absolute;top:6px;padding-left:12px;max-width:calc(100% - 115px);"], theme.typography.fonts.primary, theme.typography.sizes.small, theme.measurements.extraExtraLarge, getTitleColor(theme, errorMode, darkMode, false));
});
var StyledErrorIcon = (0, import_styled_components.default)(import_Icon.Icon).withConfig({
  displayName: "InputSearchstyled__StyledErrorIcon",
  componentId: "sc-18s6gv0-3"
})(function(_ref4) {
  var theme = _ref4.theme, darkMode = _ref4.darkMode;
  return (0, import_styled_components.css)(["color:", ";font-size:17px;line-height:24px;position:relative;top:2px;"], darkMode ? theme.colors.status.error[20] : theme.colors.status.error[100]);
});
var StyledInputSearchContainer = import_styled_components.default.div.withConfig({
  displayName: "InputSearchstyled__StyledInputSearchContainer",
  componentId: "sc-18s6gv0-4"
})(function(_ref5) {
  var _ref5$customWidth = _ref5.customWidth, customWidth = _ref5$customWidth === void 0 ? "200px" : _ref5$customWidth;
  return (0, import_styled_components.css)(["align-items:center;display:flex;font-size:24px;position:relative;width:100%;max-width:", ";input:focus ~ button:last-of-type{height:52px;}input:focus ~ button:last-of-type:hover{margin:2px;width:51px;height:52px;}input:focus ~ button:last-of-type:hover span{margin-left:2px;}}"], customWidth);
});
var StyledInputSearchButton = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "InputSearchstyled__StyledInputSearchButton",
  componentId: "sc-18s6gv0-5"
})(function(_ref6) {
  var theme = _ref6.theme, darkMode = _ref6.darkMode, errorMode = _ref6.errorMode, disabled = _ref6.disabled, withDisabledStyles = _ref6.withDisabledStyles;
  return (0, import_styled_components.css)(["position:absolute;padding:16px;display:flex;justify-content:center;align-items:center;border-top:0;border-right:0;border-bottom:0;background-color:transparent;", " right:0px;cursor:", ";box-shadow:none;color:", ";border-radius:0;height:54px;i{margin:0;color:", ";}&:focus{border-radius:0px 3px 3px 0px;", ";", ";margin-right:0.7px;width:52px;height:54.5px;}&:focus span{margin-left:0.5px;}&:not(:disabled):not([aria-disabled]):hover{i{color:", ";}box-shadow:none;border:none;", ";", ";margin:1px;width:52px;height:54px;border-radius:0px 2.5px 2.5px 0px;}&:hover span{margin-left:1px;}&:not(:disabled):active{border:none;", ";margin:1px;width:52px;height:54px;border-radius:0px 2.5px 2.5px 0px;}"], !(disabled || withDisabledStyles) && darkMode && "border-left: 1px solid ".concat(theme.colors.beige[140], ";"), disabled || withDisabledStyles ? "not-allowed" : "pointer", getIconColor(theme, errorMode, darkMode, disabled || withDisabledStyles), getIconColor(theme, errorMode, darkMode, disabled || withDisabledStyles), darkMode ? "box-shadow: inset 0 0 0 1px ".concat(theme.colors.n.white) : "box-shadow: inset 0 0 0 1px ".concat(theme.colors.n[100]), darkMode ? "border-left: 1px solid ".concat(theme.colors.n.white) : "border-left: 1px solid ".concat(theme.colors.n[100]), getIconColor(theme, errorMode, darkMode, disabled || withDisabledStyles), darkMode ? "background: ".concat(theme.colors.n[80]) : "background: ".concat(theme.colors.beige[40]), darkMode ? "border-left: 1px solid ".concat(theme.colors.beige[140]) : "border-left: 1px solid ".concat(theme.colors.beige[180]), darkMode ? "border-left: 1px solid ".concat(theme.colors.n.white) : "border-left: 1px solid ".concat(theme.colors.n[100]));
});
var StyledCloseButton = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "InputSearchstyled__StyledCloseButton",
  componentId: "sc-18s6gv0-6"
})(function(_ref7) {
  var theme = _ref7.theme, darkMode = _ref7.darkMode, disabled = _ref7.disabled, errorMode = _ref7.errorMode;
  return (0, import_styled_components.css)(["display:flex;position:absolute;right:63px;border:0;background:none;color:", ";cursor:pointer;i{margin:0;color:", ";}&:focus{box-shadow:none;border-radius:4px;", ";}&:hover{box-shadow:none;background:none;", ";", ";i{color:", ";}}&:active{", ";", ";}"], getIconColor(theme, errorMode, darkMode, disabled), getIconColor(theme, errorMode, darkMode, disabled), darkMode ? (0, import_mixins.withBorder)(theme.colors.beige[160]) : (0, import_mixins.withBorder)(theme.colors.beige[180]), (0, import_mixins.withBorder)(theme.colors.beige[180]), darkMode ? "background: ".concat(theme.colors.n[100]) : "background: ".concat(theme.colors.beige[40]), getIconColor(theme, errorMode, darkMode, disabled), darkMode ? (0, import_mixins.withBorder)(theme.colors.n.white) : (0, import_mixins.withBorder)(theme.colors.n[100]), darkMode && "background: ".concat(theme.colors.n[80]));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledCloseButton,
  StyledErrorIcon,
  StyledHintMessage,
  StyledInput,
  StyledInputSearchButton,
  StyledInputSearchContainer,
  StyledLabelTitle
});
//# sourceMappingURL=InputSearch.styled.js.map